import { Spinner } from '@acorns/web-components'
import React from 'react'
import { CenteredContainer, LoadingTitle } from './styled-components'

export const Loading: React.FC<{ title?: string }> = ({ title }) => (
  <CenteredContainer isLoading={true}>
    <Spinner />
    {title && <LoadingTitle>{title}</LoadingTitle>}
  </CenteredContainer>
)
